import { MAP_OPTIONS } from 'constants/Constants';
import { fromLonLat } from 'ol/proj';

export const OlDefaultView = {
    center: fromLonLat([125.5, 36.5]),
    zoom: MAP_OPTIONS.INITIAL_ZOOM,
    maxZoom: MAP_OPTIONS.MAX_ZOOM
} as const;
